import React from 'react'

const SixthSection = () => {

    const dataLeft = [
        {
            icon: "/images/icon-container/01.png",
            title: "DIAGNOSTICA PER IMMAGINI",
            text: [
                "Radiografie",
                "Risonanza magnetica",
                "Tac",
                "Densitometria ossea Lombare/Femorale",
                "Ecocolordoppler Vascolari",
                "Ecografie",
            ]
        },
        {
            icon: "/images/icon-container/02.png",
            title: "CARDIOLOGIA",
            text: [
                "Visite Specialistiche",
                "Elettrocardiogramma",
                "Elettrocardiogramma sotto sforzo con cicloergometro",
                "Elettrocardiogramma dinamico Holter",
                "Ecocardiogramma",
                "Monitoraggio pressorio",
            ]
        },
        {
            icon: "/images/icon-container/03.png",
            title: "LABORATORIO ANALISI CLINICHE",
            text: [
                "Chimica Clinica",
                "Ematologia",
                "Microbiologia",
                "Sieroimmunologia",
            ]
        },
        {
            icon: "/images/icon-container/04.png",
            title: "ORTOPEDIA",
            text: [
                "Visite specialistiche",
                "Infiltrazioni Endoarticolari/Mesoterapia/Artrocentesi/Bendaggio",
                "Infiltrazioni Ecoguidate",
                "Onde d’urto focalizzate per uso ortopedico",
            ]
        },
        {
            icon: "/images/icon-container/05.png",
            title: "OCULISTICA",
            text: [
                "Visite Specialistiche",
                "Fundus Oculi -Tonometria",
                "Test di Shimmer -Specillazione",
                "Campo Visivo Computerizzato",
                "Valutazione Ortottica -Riabilitazione Ortottica",
            ]
        },
        {
            icon: "/images/icon-container/06.png",
            title: "NEUROLOGIA:",
            text: [
                "Visite Specialistiche",
                "Elettromiografia",
            ]
        },
        {
            icon: "/images/icon-container/07.png",
            title: "PNEUMOLOGIA",
            text: [
                "Visite Specialistiche",
                "Spirometria semplice"
            ]
        },
        {
            icon: "/images/icon-container/08.png",
            title: "DERMATOLOGIA",
            text: [
                "Visite Specialistiche",
                "Mappatura nei",
                "Asportazione Chirurgica nei",
            ]
        },
        {
            icon: "/images/icon-container/09.png",
            title: "CHIROPRATICA",
            text: []
        }
    ];

    const dataRight = [

        {
            icon: "/images/icon-container/10.png",
            title: "CHIRURGIA AMBULATORIALE/PROCTOLOGIA",
            text: [
                "Visite Chirurgiche",
                "Interventi Ambulatoriali",
                "Esame istologico",
            ]
        },

        {
            icon: "/images/icon-container/11.png",
            title: "NEUROCHIRURGIA",
            text: [
                "Visite Specialistiche per la Colonna Vertebrale",
            ]
        },
        {
            icon: "/images/icon-container/12.png",
            title: "UROLOGIA/ANDROLOGIA",
            text: [
                "Visite Specialistiche",
                "Uroflussometria",
            ]
        },
        {
            icon: "/images/icon-container/13.png",
            title: "FONIATRIA",
            text: [
                "Visite Specialistiche",
                "Laringoscopia a fibre Ottiche",
            ]
        },
        {
            icon: "/images/icon-container/14.png",
            title: "OTORINOLARINGOIATRA",
            text: [
                "Visite Specialistiche",
                "Laringoscopia a Fibre Ottiche",
                "Esame Audiometrico Tonale",
            ]
        },
        {
            icon: "/images/icon-container/15.png",
            title: "EMATOLOGIA",
            text: [
                "Visite Specialistiche",
            ]
        },
        {
            icon: "/images/icon-container/16.png",
            title: "GERIATRIA",
            text: [
                "Visite Specialistiche",
            ]
        },
        {
            icon: "/images/icon-container/17.png",
            title: "ENDOCRINOLOGIA",
            text: [
                "Visite Specialistiche",
            ]
        },
        {
            icon: "/images/icon-container/18.png",
            title: "RECUPERO E RIEDUCAZIONE FUNZIONALE",
            text: [
                "Rieducazione Posturale",
                "Tecarterapia",
                "Terapie fisiche strumentali",
                "Trattamenti chiropratici",
                "Massoterapia",
                "Idrokinesiterapia",
            ]
        },
        {
            icon: "/images/icon-container/19.png",
            title: "ODONTOIATRIA/ORTODONZIA",
            text: [
                "Estrazioni",
                "Otturazioni",
                "Devitalizzazioni",
                "Protesi",
                "Ablazione tartaro",
                "Apparecchi ortodontici fissi/mobili",
                "Bite",
            ]
        },
        {
            icon: "/images/icon-container/20.png",
            title: "CONSULENZA NUTRIZIONALE",
            text: [
                "Anamnesi",
                "Rilevazione di Misure Antropometriche",
                "Analisi Impedenziometrica",
                "Piano dietetico personalizzato",
            ]
        },
    ];

    return (
        <div className='mt-12  bg-[#8ECDDA] py-16'>

            <div className='container mx-auto'>
                <p data-aos="fade-right" className="text-left text-white text-2xl lg:text-3xl font-bold">
                    CENTRO CONGRESSI - CONVENTION CENTER
                </p>

                <p data-aos="fade-right" className='my-5 text-xl xl:text-2xl'>
                    Il Centro Congressi offre diverse soluzioni: una sala riunioni per 10 persone, la suggestiva Sala Biennale
                    con cupola di vetro per 30-50 posti, e due ampie sale attigue da 60 e 250 posti. L’Arena Congressi può
                    ospitare oltre 300 persone, con sistemi multimediali singoli o paralleli. 
                </p>
            </div>
        </div>

    )
}


export default SixthSection